<!-- <div class="wrapper">
    <div>
        <nuctrac-header (headerHidden)='setHeaderStatus($event)'></nuctrac-header>
        <div class="d-flex flex-row">
            <div *ngIf="showNavBar" class="d-flex flex-column nav-container">
                <nuctrac-navigation class="navigation shadow flex-shrink-0"></nuctrac-navigation>
            </div>
            <div>
                <span class="material-icons isNavVisible" (click)="onClickeMenuIcon()"
                    style="height: fit-content; ">menu</span>
            </div>


            <div class="d-flex flex-column main-body">

                <div [ngClass]="{'main-container1' : hideHeader, 'main-container2': !hideHeader}">
                    <div>
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div> -->
<!-- nuctracAppIdleTimeout -->
<div class="wrapper">
  <div class="container-fluid">
    <nuctrac-header
      (headerHidden)="setHeaderStatus($event)"
      (mobileHeaderHidden)="setMobileStatus($event)"
      (isMobile)="setMobileStatusSelect($event)"
    ></nuctrac-header>
  </div>
  <div
    class="contents dynamic-cont"
    [class.select-mobile-expand]="showMobilePanel && showMobile"
    [ngClass]="{
      'mt-33': hideHeader,
      'mt-expand-header': !hideHeader,
      'mobile-expand-header': showMobilePanel,
      'mobile-collapse-header': !showMobilePanel,
      'select-mobile-collapse': showMobile
    }"
  >
    <div class="container-fluid">
      <div class="row">
        <div ui-view="navbar">
          <div>
            <nuctrac-navigation></nuctrac-navigation>
          </div>
        </div>
        <div ui-view="content" class="menu-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
